import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Grid,
  Input,
} from '@chakra-ui/react';
import { ErrorMessage } from '@hookform/error-message';
import type { SnapSiteConfigEditFormDataUnvalidated } from '@snap-types/models/snap-site-config';
import type { FieldPathFn } from '@ui/components/form';
import { get, useFormContext } from 'react-hook-form';

export function ProductOperationsCountForm({
  fieldPath,
}: {
  fieldPath: FieldPathFn<SnapSiteConfigEditFormDataUnvalidated>;
}) {
  const form = useFormContext<SnapSiteConfigEditFormDataUnvalidated>();

  const thresholdFieldPath = fieldPath('threshold');
  const ltAdjustmentFieldPath = fieldPath('ltAdjustment');
  const gteAdjustmentFieldPath = fieldPath('gteAdjustment');

  return (
    <Grid
      as="fieldset"
      gap={2}
      templateColumns={{ base: '1fr', md: '1fr 1fr 1fr 1fr 1fr 1fr' }}
    >
      <FormControl
        isInvalid={!!get(form.formState.errors, thresholdFieldPath)}
        isRequired
        gridColumn="span 6"
      >
        <FormLabel htmlFor={thresholdFieldPath}>Threshold:</FormLabel>

        <Input
          {...form.register(thresholdFieldPath)}
          id={thresholdFieldPath}
          type="number"
          inputMode="decimal"
          placeholder="Threshold"
          step="0.01"
        />

        <ErrorMessage
          name={thresholdFieldPath}
          render={({ message }) => (
            <FormErrorMessage>{message}</FormErrorMessage>
          )}
        />
      </FormControl>

      <FormControl
        isInvalid={!!get(form.formState.errors, ltAdjustmentFieldPath)}
        isRequired
        gridColumn={{ base: 'span 6', md: 'span 3' }}
      >
        <FormLabel htmlFor={ltAdjustmentFieldPath}>
          Less Than Adjustment:
        </FormLabel>

        <Input
          {...form.register(ltAdjustmentFieldPath)}
          id={ltAdjustmentFieldPath}
          type="number"
          inputMode="decimal"
          placeholder="< Threshold"
          step="0.01"
        />

        <ErrorMessage
          name={ltAdjustmentFieldPath}
          render={({ message }) => (
            <FormErrorMessage>{message}</FormErrorMessage>
          )}
        />
      </FormControl>

      <FormControl
        isInvalid={!!get(form.formState.errors, gteAdjustmentFieldPath)}
        isRequired
        gridColumn={{ base: 'span 6', md: 'span 3' }}
      >
        <FormLabel htmlFor={gteAdjustmentFieldPath}>
          Greater Than or Equal Adjustment:
        </FormLabel>

        <Input
          {...form.register(gteAdjustmentFieldPath)}
          id={gteAdjustmentFieldPath}
          type="number"
          inputMode="decimal"
          placeholder=">= Threshold"
          step="0.01"
        />

        <ErrorMessage
          name={gteAdjustmentFieldPath}
          render={({ message }) => (
            <FormErrorMessage>{message}</FormErrorMessage>
          )}
        />
      </FormControl>
    </Grid>
  );
}
